import { toLonLat } from "ol/proj";
import { useMemo, useState } from "react";
import { RLayerVector } from "rlayers";
import { ReactNodeDialog } from '../../common/utils/dialogUtlities';
import { useTranslation } from 'react-i18next';
import DataTable from '../../common/components/DataTable';
import { RDraw } from 'rlayers/interaction';
import useNetwork from '../../common/hooks/networkHook';
import { createMapPath, removeMapPath, updateMapPath, useMapPaths } from '../../reducers/mapPathSlice';

export const PathEditor = ({ show, onClose }) => {
    const { t } = useTranslation();
    const network = useNetwork();
    const [drawing, setDrawing] = useState(false);
    const [newPath, setNewPath] = useState();
    const paths = useMapPaths();

    const pathColumns = t => [
        { title: t('name'), type: "text", editable: false, readonly: true, maxlength: 255, field: "name", required: true },
        { title: t('group'), type: "text", editable: true, field: "group", maxlength: 128 },
        { title: t('visible'), type: "checkbox", editable: true, field: "visible" },
        { title: t('zIndex'), type: "number", min: 0, step: 1, editable: true, field: "zindex", required: true },
        { title: t('color'), type: "colorpicker", editable: true, field: "color" },
        { title: t('width'), type: "number", min: 0, step: 1, editable: true, field: "width" }
    ];

    const columns = useMemo(() => pathColumns(t), [t]);

    const newDefault = useMemo(() => ({ color: '#000000', zindex: 1, width: 2 }), []);

    const footerColumns = useMemo(() => {
        const def = pathColumns(t);
        def[0].editable = true;
        def[0].readonly = false;
        return def;
    }, [t]);

    const handleDelete = entry => {
        removeMapPath(network, entry.id);
    };
    const handleUpdate = (path, field, value) => {
        const delta = { id: path.id };
        delta[field] = value;
        updateMapPath(network, delta);
    };
    const handleDraw = newPath => {
        setNewPath(newPath);
        setDrawing(true);
    };
    const handleAdd = event => {
        newPath.path = event.feature.getGeometry().getCoordinates().map(c => toLonLat(c));
        setDrawing(false);
        createMapPath(network, newPath);
        setNewPath();
    };

    return <>
        <ReactNodeDialog title="Edit Map Paths" size="lg" showModal={!drawing && show} onClose={() => { setDrawing(false); onClose(); }}>
            <DataTable columns={columns} footerColumns={footerColumns} defaultSort={['name']} value={paths} newDefault={newDefault} onAdd={handleDraw} onRemove={handleDelete} onUpdate={handleUpdate}></DataTable>
        </ReactNodeDialog>
        {drawing ? <RLayerVector zIndex={1000}><RDraw type="LineString" onDrawEnd={handleAdd} onDrawAbort={() => { setNewPath(); setDrawing(false); }}></RDraw></RLayerVector> : null}
    </>;
};
